<template>
  <b-container id="header-container" fluid>
    <b-row class="justify-content-center">
      <b-col md="10">
        <!--
        <b-row align-h="between">
          <b-col md="6">
            <a href="/">
              <img alt="gravity logo" src="../../assets/logo.png" />
            </a>
          </b-col>
          <b-col md="6" class="join-button">
            <a
              href="https://zoom.us/webinar/register/WN_amII22BgS2C0_NlExIbqFw"
              target="_blank"
            >
              <b-button class="button-white-transparen"
                >Join Live Shows</b-button
              >
            </a>
          </b-col>
        </b-row>
        -->
        <b-row align-h="start" class="text-content">
          <b-col>
            <h1 class="text-white title text-left">Masters of Marketing</h1>
          </b-col>
        </b-row>
        <b-row align-h="start">
          <b-col class="mt-2">
            <h2 class="text-white sub-title text-left">Where visionary marketers share their formulas</h2>
          </b-col>
        </b-row>
        <b-row align-h="start">
          <b-col class="mt-1">
            <h3 class="text-white second-sub-title text-left">Season 2 premiers January 7th, 2021</h3>
          </b-col>
        </b-row>
        <b-row align-h="start">
          <b-col
            cols="12"
            md="6"
            class="d-flex mt-2 justify-content-center justify-content-md-start"
          >
            <a
              href="https://www.facebook.com/groups/themastersofmarketing/"
            >
              <b-button class="calendar-button">
                Join the community
              </b-button>
            </a>

          </b-col>
        </b-row>

        <b-row align-h="start">
          <b-col
            cols="12"
            md="6"
            class="d-flex mt-2 justify-content-center justify-content-md-start"
          >
            <a
              href="/shows/crush-your-quota"
            >
              <b-button class="calendar-button">
                Watch our Sales Show
              </b-button>
            </a>
          </b-col>
        </b-row>
        <!--
        <b-row align-h="start">
          <b-col
            cols="12"
            md="6"
            class="d-flex mt-2 justify-content-center justify-content-md-start"
          >
            <a
              href="https://www.facebook.com/groups/themastersofmarketing/"
            >
              <b-button class="calendar-button">
                Watch on Facebook Live
              </b-button>
            </a>
          </b-col>
        </b-row>
        -->
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/header.sass
</style>

<script>
export default {
  name: 'Header',
}
</script>
